const accordion = () => {
  initialaccordion('.mrMobiMenu-listItem-content');

  /**
   * accordion
   * parentClass: it is the current accordion's parent element's class
   * should have this class to only add accordion logic for a sepecific one
   */
  function initialaccordion(parentClass) {
    $(`${parentClass} .mrCommon-accordion-label`).on('click', (e) => {
      $('.mrCommon-accordion-label').removeClass('selected');
      $(e.currentTarget).addClass('selected');
    });
  }
};

export default accordion;
